/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import fileDownload from "js-file-download";

import SVG from "../../../components/SVG";
import { ModalView } from "../../../components/simple";
import LimitWarning from "./LimitWarning";
import PlatformsList from "./PlatformsList";
import Facebook from "./Facebook";
import Google from "./Google";
import Adform from "./Adform";
import GoogleAds from "./GoogleAds";
import TheTradeDesk from "./TheTradeDesk";
import Snapchat from "./Snapchat";
import Xandr from "./Xandr";
import PostalCodes from "./SmartClip";

import Congratulations from "./Congratulations";

import styles from "./push-modal.module.scss";
import "./push-modal.scss";
import API from "../../../api";
import * as routes from "../../../router/routes";

import { PLATFORMS } from "./platforms";
import LLCoordinates from "./LLCoordinates/LLCoordinates";

class PushModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pushAnyway: false,
      // isAdFormPopover: false,
      selectedPlatform: null,
      isAuthorized: false,
      lineItemId: "",
      isSuccess: false,
      fbData: null,
      adsetId: "",
      customerId: "",
      campaignId: "",
      ttdPartnerId: ""
    };
  }

  componentDidMount() {
    const { adformToken, snapchatToken } = this.props;

    if (adformToken.length > 0) {
      this.setState({ selectedPlatform: PLATFORMS.adform, isAuthorized: true });
    } else if (snapchatToken.length > 0) {
      this.setState({
        selectedPlatform: PLATFORMS.snapchat,
        isAuthorized: true
      });
    }
  }

  componentWillReceiveProps(newProps) {
    const { adformToken, snapchatToken } = this.props;
    const {
      adformToken: adformTokenNew,
      snapchatToken: snapchatTokenNew
    } = newProps;
    /* eslint-disable */
    if ((adformToken === "", adformTokenNew.length > 0)) {
      this.setState({ selectedPlatform: PLATFORMS.adform, isAuthorized: true });
    }

    if ((snapchatToken === "", snapchatTokenNew.length > 0)) {
      this.setState({
        selectedPlatform: PLATFORMS.snapchat,
        isAuthorized: true
      });
    }
    /* eslint-enable */
  }

  handlePlatformSelect = platform => {
    this.setState({ selectedPlatform: platform });
  };

  handleLineItemChange = value => {
    this.setState({ lineItemId: value });
  };

  handleAdsetIdChange = value => {
    this.setState({ adsetId: value });
  };

  handleGoogleAdsFieldsChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleTtdPartnerIdChange = value => this.setState({ ttdPartnerId: value });

  handleSignin = async platform => {
    switch (platform) {
      case PLATFORMS.adform:
      case PLATFORMS.snapchat: {
        const { onClose, audience, clientId } = this.props;

        const callbackUrl = window.location.pathname;
        localStorage.setItem(
          `${platform}Redirect`,
          JSON.stringify({ callbackUrl, audience, clientId })
        );

        try {
          const authorizeLink = await API.platforms[
            platform
          ].getAuthorizeLink();
          if (authorizeLink.query && authorizeLink.query.length) {
            onClose();
            window.open(authorizeLink.query, "_parent");
          }
        } catch (error) {
          console.log(error);
        }
        break;
      }

      case PLATFORMS.facebook:
        console.log("Facebook login");

        break;

      default:
        break;
    }
  };

  handlePushToPlatform = async (platform, data = {}) => {
    // const { audience: { id } = {}, clientId } = this.props;
    const { audience = {}, clientId } = this.props;

    const {
      selectedPlatform,
      // lineItemId,
      fbData,
      // adsetId,
      // customerId,
      // campaignId,
      ttdPartnerId
    } = this.state;

    const id = audience.id || audience.audience.id;

    const idType = this.props.audience.audienceVariables
      ? "audience_id"
      : "preset_id";

    if (selectedPlatform === PLATFORMS.adform) {
      if (id) {
        try {
          await API.platforms.adform.push({
            data: {
              // line_item_id: lineItemId,
              line_item_id: data.lineitemId,
              [idType]: id,
              client_id: clientId,
              adform_flow: data.adFormFlow
            }
          });
          // Error handling
          this.setState({ isSuccess: true });
        } catch (error) {
          console.error(error);
        }
      }
    }

    if (selectedPlatform === PLATFORMS.facebook) {
      if (id) {
        try {
          await API.platforms.fb.setAccessToken({
            data: {
              accessToken: fbData.accessToken,
              dataAccessExpirationTime: fbData.data_access_expiration_time
            }
          });

          await API.platforms.fb.push({
            // data: { adsetId, [idType]: id, client_id: clientId }
            data: { adset_id: data.adsetId, [idType]: id, client_id: clientId }
          });

          this.setState({ adsetId: "", isSuccess: true });
        } catch (err) {
          console.error(err);
        }
      }
    }

    if (selectedPlatform === PLATFORMS.googleAds) {
      if (id) {
        try {
          await API.platforms.googleAds
            .push({
              data: {
                customer_id: data.customerId,
                campaign_id: data.campaignId,
                [idType]: id,
                client_id: clientId
              }
            })
            .then(() =>
              this.setState({ customerId: "", campaignId: "", isSuccess: true })
            );
        } catch (err) {
          console.error(err);
        }
      }
    }

    if (selectedPlatform === PLATFORMS.ttd) {
      if (id) {
        try {
          const response = await API.platforms.Ttd.push({
            data: {
              partnerId: ttdPartnerId,
              [idType]: id
            }
          });

          if (response.type !== "TTD_PUSH_FAILED")
            this.setState({ isSuccess: true, ttdPartnerId: "" });
        } catch (err) {
          console.error(err);
        }
      }
    }

    if (selectedPlatform === PLATFORMS.snapchat) {
      if (id) {
        try {
          await API.platforms.snapchat
            .push({
              // data: { adset_id: adsetId, [idType]: id, client_id: clientId },
              data: {
                adset_id: data.adsetId,
                [idType]: id,
                client_id: clientId
              }
            })
            .then(() => this.setState({ adsetId: "", isSuccess: true }));
        } catch (err) {
          console.error(err);
        }
      }
    }
    if (selectedPlatform === PLATFORMS.xandr) {
      if (id) {
        try {
          await API.platforms.xandr
            .push({
              data: {
                line_item_id: data.lineItemsId,
                [idType]: id,
                client_id: clientId
              }
            })
            .then(() => this.setState({ adsetId: "", isSuccess: true }));
        } catch (err) {
          console.error(err);
        }
      }
    }
  };

  // closeAdformPopover = () => {
  //   this.setState({ isAdFormPopover: false });
  // };

  responseFacebook = response => {
    if (process.env.NODE_ENV === "development") {
      // console.log(response);
    }

    this.setState({ fbData: response });
  };

  editAudienceHandler = () => {
    const { audience } = this.props;

    return this.props.history.push({
      pathname: routes.audiencesCreateWithoutTemplate(audience.id),
      state: {
        country: audience.country,
        audience
      }
    });
  };

  render() {
    const {
      pushAnyway,
      // isAdFormPopover,
      selectedPlatform,
      isAuthorized,
      lineItemId,
      isSuccess,
      fbData,
      adsetId,
      customerId,
      campaignId,
      ttdPartnerId
    } = this.state;
    const {
      isOpen,
      onClose,
      audience,
      user,
      pushTtdError,
      clientId
    } = this.props;

    const isFreemium = user?.company?.currentSubscription === "Freemium";
    const audienceType = audience.audienceVariables ? "audience" : "preset";
    const country = audience?.country?.code;

    if (isSuccess) {
      return (
        <ModalView
          audienceType={audienceType}
          audience={audience}
          clientId={clientId}
          isOpen={isOpen && isSuccess}
          handleClose={() => {
            if (isSuccess) {
              this.setState({
                selectedPlatform: null,
                isSuccess: false,
                isAuthorized: false,
                lineItemId: ""
              });
            }
            onClose();
          }}
        >
          <Congratulations
            selectedPlatform={selectedPlatform}
            isSuccess={isSuccess}
            audience={audience}
            onClose={onClose}
            audienceType={audienceType}
            clientId={clientId}
          />
        </ModalView>
      );
    }

    return (
      <ModalView
        className={styles.modal}
        contentClassName={styles.content}
        centered
        isOpen={isOpen}
        toggle={() => {
          if (isSuccess) {
            this.setState({
              selectedPlatform: null,
              isSuccess: false,
              isAuthorized: false,
              lineItemId: ""
            });
          }
          onClose();
        }}
        handleClose={() => {
          if (isSuccess) {
            this.setState({
              selectedPlatform: null,
              isSuccess: false,
              isAuthorized: false,
              lineItemId: ""
            });
          }
          onClose();
        }}
      >
        {!isSuccess && (
          <PlatformsList
            onShow={pushAnyway || isFreemium}
            selectedPlatform={selectedPlatform}
            isAuthorized={isAuthorized}
            audience={audience}
            country={country}
            handlePlatformSelect={this.handlePlatformSelect}
          />
        )}

        <LimitWarning
          onShow={!pushAnyway && isFreemium}
          onPushAnyway={() => {
            this.setState({ pushAnyway: true });
          }}
          onContactMe={() => {
            // eslint-disable-next-line no-alert
            alert("Contact");
          }}
        />

        <Facebook
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          fbData={fbData}
          responseFacebook={this.responseFacebook}
          audienceId={audience?.id}
          handlePushToPlatform={this.handlePushToPlatform}
          handleAdsetIdChange={this.handleAdsetIdChange}
          adsetId={adsetId}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        <Google
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          onDownload={async () => {
            const response = await API.platforms.google.download({
              audienceType,
              audienceValue: audience?.id,
              clientId
            });
            fileDownload(response, `${audience.name}-LL.csv`);
          }}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        <Adform
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          handleSignin={this.handleSignin}
          isAuthorized={isAuthorized}
          handlePushToPlatform={this.handlePushToPlatform}
          lineItemId={lineItemId}
          handleLineItemChange={this.handleLineItemChange}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        <GoogleAds
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          customerId={customerId}
          campaignId={campaignId}
          audienceId={audience?.id}
          handlePushToPlatform={this.handlePushToPlatform}
          handleGoogleAdsFieldsChange={this.handleGoogleAdsFieldsChange}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        <TheTradeDesk
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          handlePushToPlatform={this.handlePushToPlatform}
          ttdPartnerId={ttdPartnerId}
          handleTtdPartnerIdChange={this.handleTtdPartnerIdChange}
          fieldError={pushTtdError}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        <Snapchat
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          handleAdsetIdChange={this.handleAdsetIdChange}
          adsetId={adsetId}
          handlePushToPlatform={this.handlePushToPlatform}
          handleSignin={this.handleSignin}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        {country !== "GB" ? (
          <Xandr
            audienceType={audienceType}
            editAudienceHandler={this.editAudienceHandler}
            selectedPlatform={selectedPlatform}
            handlePushToPlatform={this.handlePushToPlatform}
            onDownload={async () => {
              const response = await API.platforms.xandr.download({
                audienceType,
                audienceValue: audience?.id,
                clientId
              });
              fileDownload(response, `${audience.name}-xandr.csv`);
            }}
            onDownloadZip={async () => {
              const response = await API.platforms.xandr.downloadZIP({
                audienceType,
                audienceValue: audience?.id,
                clientId
              });
              fileDownload(response, "zips.csv");
            }}
            allowEdit={this.props.currentSubscription !== "Light"}
          />
        ) : null}

        <PostalCodes
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          selectedPlatform={selectedPlatform}
          onDownload={async () => {
            const response = await API.platforms.postalCodes.download({
              audienceType,
              audienceValue: audience?.id,
              clientId
            });
            fileDownload(response, `${audience.name}-ZIP.csv`);
          }}
          allowEdit={this.props.currentSubscription !== "Light"}
        />
        <LLCoordinates
          onDownload={async () => {
            const response = await API.platforms.llCoordinates.download({
              audienceType,
              audienceValue: audience?.id,
              clientId
            });
            fileDownload(response, `${audience.name}-LL.csv`);
          }}
          selectedPlatform={selectedPlatform}
          audienceType={audienceType}
          editAudienceHandler={this.editAudienceHandler}
          allowEdit={this.props.currentSubscription !== "Light"}
        />

        {/* <Congratulations */}
        {/*  selectedPlatform={selectedPlatform} */}
        {/*  isSuccess={isSuccess} */}
        {/*  audience={audience} */}
        {/*  onClose={onClose} */}
        {/* /> */}

        {!isSuccess ? (
          <button
            type="button"
            disabled={!selectedPlatform}
            className={`${styles.back} ${
              selectedPlatform ? styles["slide-from-right"] : ""
            }`}
            onClick={() => {
              this.setState({ selectedPlatform: null });
            }}
          >
            {selectedPlatform ? <SVG.Arrow2 /> : null}
          </button>
        ) : null}
      </ModalView>
    );
  }
}

PushModal.propTypes = {
  user: PropTypes.shape({
    company: PropTypes.shape({
      currentSubscription: PropTypes.string
    })
  }).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  audience: PropTypes.shape({
    name: PropTypes.string,
    audienceVariables: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    id: PropTypes.string.isRequired,
    country: PropTypes.shape({
      code: PropTypes.string
    }).isRequired
  }),
  adformToken: PropTypes.string,
  snapchatToken: PropTypes.string,
  pushTtdError: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  currentSubscription: PropTypes.string.isRequired
};

PushModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  adformToken: "",
  snapchatToken: "",
  audience: { name: "" },
  pushTtdError: ""
};

const mapStateToProps = props => {
  const { platforms } = props;
  return {
    pushIsLoading: platforms.isLoading,
    pushTtdError: platforms.ttdError
  };
};

export default withRouter(connect(mapStateToProps)(PushModal));
